import { render, staticRenderFns } from "./ProductMatchingMethodSelect.vue?vue&type=template&id=a627e734&scoped=true"
import script from "./ProductMatchingMethodSelect.vue?vue&type=script&lang=ts"
export * from "./ProductMatchingMethodSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a627e734",
  null
  
)

export default component.exports